import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-news-2022',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.styl']
})
export class News2022Component implements OnInit {

  constructor(
    private http: HttpClient,
    private router: Router) { }

  rows: any;
  loaded = false
  Objectkeys = Object.keys
  sindex = 0
  U_ROOT_URL = environment.U_ROOT_URL
  osslink = '?x-oss-process=image/resize,w_300';

  ngOnInit() {
    this.getdata()
  }

  getdata(){
    this.http.get('/pc/news?year=2022').subscribe((res) => {
      this.rows = res;
      this.loaded = true;
    })
  }

  toview(item) {
    this.router.navigateByUrl('/2022/news/' + item.id)
  }
}
